module.exports = __webpack_public_path__ + "static/media/membership_check_24.2dadaae3.svg";